<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" dark permanent app>
      <v-list nav>
        <avatar>
          <template #avatarImage>
            <v-avatar class="profile" color="grey" size="160" tile>
              <v-img
                :src="userInfo.avatarImage"
                contain
                style="background-color: white"
              ></v-img>
            </v-avatar>
          </template>
          <template #userName> {{ userInfo.userName }} </template>
          <template #email> {{ userInfo.email }} </template>
        </avatar>
        <v-divider class="mb-6"></v-divider>

        <template v-for="(item, index) in links">
          <v-list-group
            v-if="item.children"
            :key="index"
            :prepend-icon="item.icon"
            :value="true"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </template>
            
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              :to="child.path"
              link
            >
              <v-list-item-icon>
                <v-icon v-if="child.icon">{{ child.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ child.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-item
            v-else
            :key="index"
            :to="item.path"
            color="blue"
            link
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list-item link @click="logout">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>登出</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title>即刻上岸</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn icon>
        <v-icon @click="logout"> mdi-logout </v-icon>
      </v-btn>
    </v-app-bar>

    <v-container class="py-8 px-6" fluid>
      <router-view></router-view>
    </v-container>
  </v-app>
</template>

<script>
import { removeToken } from "@/utils/auth";
import { PlatformChildrenRouterList } from "@/router/platformChildrenRouterList";
import Avatar from "../components/Avatar.vue";

export default {
  components: { Avatar },
  data: () => ({
    userInfo: {
      // @/assets/cabo.jpg
      avatarImage: require("../assets/jikeshangan_logo.png"),
      userName: "ADMIN",
      email: "",
    },
    drawer: false,
    links: [...PlatformChildrenRouterList],
  }),
  methods: {
    forwardToAccountInfo() {
      this.$router.push({
        name: "accountInfo",
      });
    },
    logout() {
      console.log("click logout");
      removeToken();
      this.$router.push({ path: "/Login" });
    },
  },
};
</script>